import React, { useState, useEffect } from "react";
import Container from "../../../components/Container/Container";
import ClubForm from "../../../components/Club/ClubForm";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { API } from "../../../constants/env";
import { useParams } from "react-router-dom";

const EditClub = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const { register, handleSubmit, errors, reset } = useForm();
  const onSubmit = (data) => {
    fetch(API.club.update(id), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }
        return swal("Good", "Club modifié", "success");
      })
      .catch((e) => {
        return swal(
          "Failed",
          "Something went wrong! check the server ",
          "error"
        );
      });
  };

  useEffect(() => {
    const fetchdata = async () => {
      fetch(API.club.info(id), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            return swal("Error", response.message, "error");
          }
          setData(response);
        })
        .catch((e) => {});
    };
    fetchdata();
  }, []);

  return (
    <Container name="Modifier Club" back={true} backRoute="/club" submit={true}>
      <ClubForm
        registerRequired={register({ required: true })}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        reset={reset}
        data={data}
      />
    </Container>
  );
};

export default EditClub;
